module.exports = __webpack_public_path__ + "img/check-rounded-blue.215fa709.svg";